import { InputAdornment, TextField } from '@mui/material'
import clsx from 'clsx'
import { ReactNode } from 'react'

import style from './TextFieldDescribed.module.css'

const TextFieldDescribed = ({
  description = undefined,
  error = '',
  hasError = false,
  defaultValue,
  placeholder,
  disabled = false,
  rightLabel,
  type = 'text',
  className,
  onChange,
  children,
  value,
  noBorder = false,
  textAlign = 'left',
}: {
  description: string | undefined
  error?: string
  hasError?: boolean
  defaultValue?: string | number
  value?: string | number
  placeholder: string
  disabled?: boolean
  type?: string
  rightLabel?: string
  className?: string
  onChange: (e: any) => void
  children?: ReactNode
  noBorder?: boolean
  textAlign?: 'left' | 'right' | 'center'
}) => {
  return (
    <div className={className}>
      <div className={clsx('text-14-400', style.subtitle)}>{description}</div>
      <div className={style.flexRow}>
        <TextField
          variant="outlined"
          placeholder={placeholder}
          fullWidth
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
          type={type}
          sx={{
            '& fieldset': {
              borderRadius: '0px',
              border: noBorder ? 'none' : hasError ? 'solid 1px var(--color-error-dark)' : 'solid 1px #DADDE5',
            },
            '& .MuiInputBase-root': {
              height: '40px',
              fontSize: '14px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: noBorder ? 'none' : hasError ? 'solid 1px var(--color-error-dark)' : 'solid 1px #DADDE5',
            },
          }}
          InputProps={{
            endAdornment: children && <InputAdornment position="end">{children}</InputAdornment>,
          }}
          inputProps={{
            style: { textAlign },
          }}
        />
        {rightLabel && <div className={style.rightLabel}>{rightLabel}</div>}
      </div>
      {hasError ? <div className={style.error}>{error}</div> : null}
    </div>
  )
}

export default TextFieldDescribed
